import type { FunctionComponent, ReactNode } from 'react';

// TODO: Replace by error boundary from Sentry.
import { ErrorBoundary } from 'react-error-boundary';

import { Button, Link } from '@dr.pogodin/react-utils';
import { captureException } from '@sentry/react';

import { getConfig } from 'utils';

import Logo from 'assets/images/logo-soul-sanctuary-new-150px.svg';

import './style.scss';

const Fallback = (): ReactNode => {
  const config = getConfig(true);
  return (
    <div styleName="container">
      <Logo />
      <h1>Let&apos;s start that again.</h1>
      <p>
        Something on our side interrupted things.
        A refresh should bring you right back.
      </p>
      <Button
        onClick={() => {
          location.reload();
        }}
      >
        Refresh
      </Button>
      <p>
        If it keeps happening, please &zwnj;
        <Link to={`mailto:${config.SUPPORT_EMAIL}`}>
          contact support
        </Link>.
      </p>
    </div>
  );
};

type PropsT = {
  children: ReactNode;
};

export const RenderErrorPage: FunctionComponent<PropsT> = ({
  children,
}) => (
  <ErrorBoundary
    fallbackRender={Fallback}
    onError={(error) => {
      captureException(error);
    }}
  >
    {children}
  </ErrorBoundary>
);
